<template>
  <v-card class="pa-4">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">QuickOrder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_nuovo_ordine = true"
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi ordine</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <ListaOrdini ref="lista"/>
      </v-card-text>
    </v-card>

    <!-- Dialog di aggiunta evento -->
    <v-dialog v-model="dialog_nuovo_ordine" persistent>
      <NuovoOrdine
        :key="dialog_nuovo_ordine"
        @goBack="dialog_nuovo_ordine = false; refresh()"
        @salvataggio_effettuato="refresh()"
      />
    </v-dialog>
  </v-card>
</template>


<script>
import ListaOrdini from "@/components/CREAZIONE_SF/ListaOrdini.vue";
import NuovoOrdine from "@/components/CREAZIONE_SF/NuovoOrdine.vue";

export default {
  name: "QNotice",
  components: { ListaOrdini, NuovoOrdine},
  props: {},
  data() {
    return {
      //Variabili di supporto

      //Modali

      dialog_nuovo_ordine: false,

      //Array
    };
  },

  methods: {
    clickIndietro() {
      this.$router.push("/home/production");
    },

    refresh(){
      // Da inserire nella lista degli ordini
      this.$refs.lista.getOrdini();
    }
  },

  computed: {},

  watch: {},

  mounted() {},
};
</script>
<style scoped>
</style>